import { useMemo } from 'react'
import { isMaldivesCharterBundleOffer } from 'constants/charterFlight'
import useAlternativeOffers from 'hooks/Offers/useAlternativeOffers'
import useOffers from 'hooks/Offers/useOffers'
import { useAppSelector } from 'hooks/reduxHooks'
import { scheduleIsCurrent } from 'lib/offer/scheduleStatusUtils'
import { isMaldivesCharterRegionEnabled } from 'selectors/maldivesSelectors'

/** Reuse the offer page's property relationships; offer IDs must never define eligibility. */
export default function useSamePropertyCharterOffer(source: App.HotelOffer) {
  const regionEnabled = useAppSelector(isMaldivesCharterRegionEnabled)
  const enabled = regionEnabled && !isMaldivesCharterBundleOffer(source)
  const alternatives = useAlternativeOffers(source.property.id, 'le', { disabled: !enabled })
  const offerIds = useMemo(() => enabled ? alternatives?.le.filter(id => id !== source.id) ?? [] : [], [enabled, alternatives, source.id])
  const [offers, fetching] = useOffers<App.HotelOffer>(offerIds)
  const charterOffer = useMemo(() => offers.find(offer =>
    offer.property?.id === source.property.id && isMaldivesCharterBundleOffer(offer) && scheduleIsCurrent(offer.onlinePurchaseSchedule),
  ), [offers, source.property.id])
  return { charterOffer: enabled ? charterOffer : undefined, fetching: enabled && (!alternatives || fetching) }
}
